import { render, staticRenderFns } from "./InfoSubTitle.vue?vue&type=template&id=186087f8&scoped=true&"
import script from "./InfoSubTitle.vue?vue&type=script&lang=js&"
export * from "./InfoSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoSubTitle.vue?vue&type=style&index=0&id=186087f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186087f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186087f8')) {
      api.createRecord('186087f8', component.options)
    } else {
      api.reload('186087f8', component.options)
    }
    module.hot.accept("./InfoSubTitle.vue?vue&type=template&id=186087f8&scoped=true&", function () {
      api.rerender('186087f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/InfoSubTitle.vue"
export default component.exports